import hocs from 'common-hocs';
import Game from './game.presentation';
import { selectUser } from 'cognito-redux/selectors';
import { logout } from 'cognito-redux/actions';
//This container file may be modified for future use

const mapState = (state) => ({
    user: selectUser(state)
});

const mapDispatch = {
    logout
};

export default hocs({ redux: { mapState, mapDispatch }, i18n: ['game'], router: true })(Game);



// WEBPACK FOOTER //
// ./src/game/game.container.jsx